
export const ButtonIcon = ({children}) => {
    return (
        <>
            {children}
        </>
    )
}
